import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import { ConnectedRouter } from 'connected-react-router';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import './index.css';
import * as serviceWorker from './serviceWorker';
import log from './logger';
import configureStore, { history } from './redux/configureStore';
import config from './constants/config';
import InitiateApplication from './InitiateApplication';

if (process.env.REACT_APP_NODE_ENV !== 'local') {
  log();
}

const store = configureStore();

if (config) {
  ReactDOM.render(
    <Provider store={ store }>
      <ConnectedRouter history={ history } noInitialPop>
        <InitiateApplication
          config={ config }
          ssoAuthConfig={ config?.features?.login?.ssoAuthConfig }
        />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
  );
} else {
  // eslint-disable-next-line no-console
  console.log({ carrier: process.env.REACT_APP_CARRIER_ID, config });
  window.location.href = '/page-not-found.html';
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
